// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LoadingModal__content--O02qu{text-align:center}.LoadingModal__loadingText--g00uZ{margin:0;padding-top:8px}`, "",{"version":3,"sources":["webpack://./src/js/components/organisms/modals/LoadingModal.vue"],"names":[],"mappings":"AAEA,8BACE,iBAAA,CAGF,kCACE,QAAA,CACA,eAAA","sourcesContent":["@use '@/scss/lib/base/variables' as *;\n\n.content {\n  text-align: center;\n}\n\n.loadingText {\n  margin: 0;\n  padding-top: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `LoadingModal__content--O02qu`,
	"loadingText": `LoadingModal__loadingText--g00uZ`
};
module.exports = ___CSS_LOADER_EXPORT___;
